/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 19:25:20
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { LoadingService } from './loading.service';

@Component({
  selector: 'dt-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  isLoading = false; // æ§å¶å¨ç»æ¾ç¤º/éè

  constructor(private loadingService: LoadingService) {}

  ngOnInit() {
    // æ¥æ¶ç¶æåå
    this.subscription = this.loadingService.$toggle.subscribe((res) => (this.isLoading = Boolean(res)));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
